import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import ListItemText1 from 'Components/ComponentLibrary/Components/Uncategorized/ListItemText/ListItemText1';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import List1 from 'Components/ComponentLibrary/Components/Lists/List1';
import ListItem2 from 'Components/ComponentLibrary/Components/ListItems/ListItem2';
import ListItemAvatar1 from 'Components/ComponentLibrary/Components/Uncategorized/ListItemAvatar/ListItemAvatar1';
import IconPicker from 'Components/ComponentLibrary/Organisms/IconPicker';

const useStyles = buildUseStyles('HierarchicalListNodeContentListItem', ((theme) => ({
  root: {
    width: theme.dimensions.md,
  },
})));

const HierarchicalListNodeContentListItem = ({
  resource,
  onClickItem,
}) => {
  const classes = useStyles();

  return (
    <Paper
      className={classes.root}
      variant={'outlined'}
      rounded
    >
      <List1 disablePadding>
        <ListItem2
          button={onClickItem !== null}
          onClick={() => {
            if (onClickItem !== null) {
              onClickItem(resource);
            }
          }}
        >
          <ListItemAvatar1>
            <IconPicker
              resource={resource}
            />
          </ListItemAvatar1>
          <ListItemText1
            primary={resource.attr('primaryText')}
            secondary={resource.attr('secondaryText')}
          />
        </ListItem2>
      </List1>
    </Paper>
  );
};

HierarchicalListNodeContentListItem.defaultProps = {
  onClickItem: null,
};

HierarchicalListNodeContentListItem.propTypes = {
  resource: PropTypes.object.isRequired,
  onClickItem: PropTypes.func,
};

export default HierarchicalListNodeContentListItem;
